.preview {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  background: var(--gray-300);
  color: var(--text-primary);
}

.preview:focus {
  outline: none;
}

.bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--gray-300);
  background: var(--white);
}

.barTitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.actions {
  display: flex;
  gap: 8px;
}

.sheets {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 24px 16px;
  overflow: auto;
}

.page {
  display: flex;
  flex: none;
  flex-direction: column;
  box-sizing: content-box;
  width: 191.9mm;
  height: 255mm;
  padding: 12mm;
  overflow: hidden;
  background: var(--white);
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.measure {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 191.9mm;
  flex-direction: column;
  visibility: hidden;
  pointer-events: none;
}

.block {
  flex: none;
}

.footer {
  display: flex;
  flex: none;
  justify-content: space-between;
  gap: 16px;
  padding-top: 8px;
  border-top: 1px solid var(--gray-300);
  color: var(--text-secondary);
  font-size: 10px;
  line-height: 16px;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.brand {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.mark {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.logo {
  width: auto;
  height: 24px;
}

.title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.keyInfo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 24px;
  margin: 0;
}

.field {
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  gap: 8px;
  font-size: 11px;
  line-height: 16px;
}

.field dt {
  color: var(--text-secondary);
}

.field dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 16px;
  margin: 0;
  padding: 0;
  font-size: 10px;
  line-height: 16px;
  list-style: none;
}

.legend li {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.swatch {
  width: 8px;
  height: 8px;
}

.sectionTitle {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}

.events {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 11px;
  line-height: 16px;
}

.events th {
  color: var(--text-secondary);
  font-weight: 500;
  text-align: left;
}

.events th,
.events td {
  padding: 4px 8px 4px 0;
  border-bottom: 1px solid var(--gray-300);
  vertical-align: top;
  overflow-wrap: anywhere;
}

.events th:first-child,
.events td:first-child {
  width: 30%;
}

.events th:nth-child(2),
.events td:nth-child(2) {
  width: 30%;
}

.empty {
  margin: 0;
  color: var(--text-secondary);
  font-size: 11px;
}

@media print {
  .preview {
    position: static;
    display: block;
    background: none;
  }

  .bar {
    display: none;
  }

  .sheets {
    display: block;
    padding: 0;
    overflow: visible;
  }

  .page {
    padding: 0;
    box-shadow: none;
    break-after: page;
  }

  .page:last-child {
    break-after: auto;
  }
}
